import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMutationResourceCoverUpdate } from '../../resource-detail/mutations/useMutationResourceCoverUpdate.js';
import { useMutationResourceDescriptionUpdate } from '../../resource-detail/mutations/useMutationResourceDescriptionUpdate.js';
import { useMutationResourceIconUpdate } from '../../resource-detail/mutations/useMutationResourceIconUpdate.js';
import { useMutationResourceTitleRename } from '../../resource-detail/mutations/useMutationResourceTitleRename.js';
import { RootType } from '@fabric/woody-client';
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { useMutationUpdateResourceListViewPreferences } from '../mutations/useMutationUpdateResourceListViewPreferences.js';
import { getResourcePermissionsAndDisabledActions } from '../../resource-detail/components/context/getDisabledActionsReasons.js';
import { renderResourceIcon } from '../../resource-detail/components/ResourceIcon/renderResourceIcon.js';
import { EditorialViewHeader } from '../../resource-detail/components/EditorialViewHeader/EditorialViewHeader.js';
import { getResourceNamePlaceholder } from '../utils/getResourceTitle.js';
import { mergeListPreferences } from '../utils/mergeListPreferences.js';
import { useContextShareToken } from '../../permission/contexts/AnonShareTokenContext.js';

const ResourceFolderEditorialHeader = ({ folder, disableTitleEdit, viewMode, onRename }) => {
  const { mutate: mutateTitle } = useMutationResourceTitleRename(folder.id);
  const { mutate: mutateDescription } = useMutationResourceDescriptionUpdate(folder.id);
  const { mutate: mutateIcon } = useMutationResourceIconUpdate(folder.id);
  const { mutateAsync: mutateCover } = useMutationResourceCoverUpdate();
  const { mutate: mutatePreferences } = useMutationUpdateResourceListViewPreferences();
  const shareToken = useContextShareToken();
  const canEdit = useMemo(() => {
    const { disabledActions } = getResourcePermissionsAndDisabledActions(folder);
    return !disabledActions.modify && !shareToken?.isPublishedView;
  }, [
    folder,
    shareToken?.isPublishedView
  ]);
  const savedIcon = renderResourceIcon(folder);
  const canEditIconOrCover = canEdit && folder.root?.type !== RootType.INTEGRATION;
  const iconProps = {
    iconEl: savedIcon,
    isDefault: !folder.icon,
    onSave: canEditIconOrCover ? (value) => {
      mutateIcon({
        resource: folder,
        icon: value
      });
    } : void 0
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(EditorialViewHeader, {
        title: {
          defaultValue: folder.name || "",
          placeholder: getResourceNamePlaceholder(folder),
          onSave: canEdit && !disableTitleEdit ? (value) => {
            mutateTitle({
              resource: folder,
              newTitle: value
            }, {
              onSuccess: () => {
                onRename?.(value);
              }
            });
          } : void 0,
          resourceId: folder.id
        },
        description: {
          defaultValue: folder.description || "",
          onSave: canEdit ? (value) => {
            mutateDescription({
              resource: folder,
              newDescription: value
            });
          } : void 0
        },
        coverImage: {
          url: folder.cover?.url,
          yOffsetPct: folder.preferences?.coverImage?.yOffsetPct,
          onYOffsetPctChange: canEdit ? (yOffsetPct) => {
            mutatePreferences({
              type: "resources",
              id: folder.id,
              data: mergeListPreferences(folder.preferences, {
                coverImage: {
                  yOffsetPct
                }
              })
            });
          } : void 0,
          onSave: canEditIconOrCover ? (file) => mutateCover({
            resource: folder,
            cover: file
          }) : void 0
        },
        icon: iconProps
      }),
      viewMode === "List" && /* @__PURE__ */ jsx(ExtraSpace, {})
    ]
  });
};
const ExtraSpace = styled.div.withConfig({
  displayName: "ResourceFolderEditorialHeader__ExtraSpace",
  componentId: "sc-51a9d4dc-0"
})([
  `height:50px;`
]);

export { ResourceFolderEditorialHeader };
//# sourceMappingURL=ResourceFolderEditorialHeader.js.map
